import React from "react";
import { Button } from 'antd';
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import NHFetch from "../../../utils/NHFetch";

/**
 * 环节办理业务项查询列表
 * @author Xiafanglin
 * @date 2018-03-21 02:13:57
 * Version: 1.0
 */
class HjblywxIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
            },
            dmkmcList:{}
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }

    //导出Excel文件  
    handleExportBtnClick = () => {
        this.refs.nhTable.exportExcel("导出基础数据");
    };

    //获取下拉列表value对应的名称
    getDmkMc = (dmbz, zdbz) => {
        NHFetch("/proData/selectDataList", "GET", { sign: dmbz })
            .then(res => {
                if (res) {
                    if (res.data) {
                        let dmkmcList = this.state.dmkmcList;
                        dmkmcList[zdbz] = res.data;
                        this.setState({
                            dmkmcList: dmkmcList
                        })
                    }
                }
            });
    }

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                search: 'input',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '90px',
                search: 'input',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '校区',
                width: '100px',
                search: 'input',
                dataIndex: 'XQMC',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                search: 'input',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                search: 'input',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                search: 'input',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '环节名称',
                width: '120px',
                search: 'input',
                dataIndex: 'HJMC',
                searchType:"select"
            }, {
                title: '业务项名称',
                width: '120px',
                search: 'input',
                dataIndex: 'ZDMC',
                searchType:"select"
            }, {
                title: '字段值',
                width: '100px',
                search: 'input',
                dataIndex: 'YWXZMC',
                // render:(text,record)=>{
                //     const {KJCS,YWXZ,ZDBZ} = record;
                //     if(YWXZ === null){
                //         return null;
                //     }
                //     let kjcsjson = JSON.parse(KJCS);
                //     let zdzmc = '';
                //     if (kjcsjson.type === "select") {
                //         if (kjcsjson.dataTag && !this.state.dmkmcList[ZDBZ]) {
                //             this.getDmkMc(kjcsjson.dataTag, ZDBZ);
                //         }
                //         let list = this.state.dmkmcList[ZDBZ];
                //         list && list.map(item => {
                //             if (item.VALUE === YWXZ) {
                //                 zdzmc = item.LABEL;
                //             }
                //         })
                //     }else 
                //     if(kjcsjson.type === "switch"){
                //         zdzmc = (YWXZ =="true" || YWXZ == "1" || YWXZ == true )? kjcsjson.checkedText:kjcsjson.uncheckedText;
                //     } 
                //     else if(kjcsjson.type === "radio"){
                //         kjcsjson.options&&kjcsjson.options.map((item,key)=>{
                //             if(item.value === YWXZ){
                //                 zdzmc = item.label;
                //             }
                //         })
                //     }
                //     else {
                //         zdzmc = YWXZ;
                //     }
                //     return zdzmc;
                // }
                
            }
        ];
        //行内操作

        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_hjblywxcx_queryPage"}
                        columns={columns}
                        sqlParams={{ywxSign:'zhxg_yx_lcgl_ywxdy'}}
                        rangeFilter={true}
                    >
                    <Button type="primary" ghost style={{marginLeft: 10}} onClick={this.handleExportBtnClick}>导出</Button>
                    </NHTable>
                </div>
            </div>
        );
    }
}
export default HjblywxIndex;



// WEBPACK FOOTER //
// ./components/tjcx/hjblywxcx/index.js